import React, {useState} from 'react';
import {
	BrowserRouter as Router,
	Routes,
	Route,
	Navigate,
} from 'react-router-dom';
import './App.css';
import Login from './componentes/login';
import {Usuario} from './interfaces/usuarios';
import Validar from './componentes/validar';
import Home from './componentes/home';

const App: React.FC = () => {
	const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
	const [datos_usuario, setUsuario] = useState<Usuario[]>([
		{
			nombre: '',
			rut: '',
			carrera: '',
			registro: '',
			email_opcional: '',
			telefono_per: '',
			telefono_opc: '',
			carrera_codigo: '',
			plan_codigo: '',
			mencion_codigo: '',
			tipo_carrera: 'pregrado',
		},
	] as Usuario[]);
	const [registro, setRegistro] = useState<string>('');
	return (
		<Router>
			<Routes>
				<Route path='/' element={<Navigate to='/login' />} />
				<Route
					path='/login'
					element={<Login setIsLoggedIn={setIsLoggedIn} />}
				/>
				<Route
					path='/home'
					element={
						isLoggedIn ? (
							<Home
								setUsuario={setUsuario}
								setRegistro={setRegistro}
								setIsLoggedIn={setIsLoggedIn}
							/>
						) : (
							<Navigate to='/login' />
						)
					}
				/>
				<Route
					path='/validacion'
					element={<Validar userData={datos_usuario} registro={registro} />}
				/>
			</Routes>
		</Router>
	);
};

export default App;
